import { useToast } from '@dc-shared-web/components/shadcn/use-toast'
import { AIUserFeedback } from '@dc-shared-web/hooks/api/ai-user-feedback/types'
import { updateAIUserFeedback } from '@dc-shared-web/hooks/api/ai-user-feedback/updateAIUserFeedback'
import { useSvcCrunchesContext } from '@dc-shared-web/providers/SvcCrunchesProvider'
import { useMutation, useQueryClient } from 'react-query'

export const useUpdateAIUserFeedback = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation(
    (feedback: AIUserFeedback) => updateAIUserFeedback(apiClient, feedback),
    {
      onSuccess: (feedback) => {
        toast({
          variant: 'success',
          title: 'Thanks for your feedback!',
        })

        queryClient.invalidateQueries({
          queryKey: ['ai-user-feedback', `feedback-${feedback.content_uuid}`],
        })

        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error creating feedback',
          description: 'If the issue persists, please contact support.',
        })

        params?.onError?.()
      },
    }
  )
}
